<template>
  <div class="cover-image-container">
    <div class="project-name title">{{ projectName }}</div>
    <img :src="imgSrc" alt="Project cover image" />
  </div>
</template>
<script>
export default {
  props: {
    imgSrc: { required: true, type: String },
    projectName: { required: true, type: String }
  }
};
</script>
<style lang="scss" scoped>
.cover-image-container {
  min-width: 100%;
  height: 25vh;
  position: relative;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: $standard-shadow;
}

.project-name {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  text-align: center;
  align-items: center;
  position: absolute;
  top: 1rem;
  left: 1rem;
  max-width: 100%;
  max-height: 100%;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  display: inline-block;
  overflow: hidden;
}
</style>
